/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const radioPadStyle = {
  input: {
    display: "none",
  },
  wrapper: {
    width: "100%",
    margin: "1rem auto",
    textAlign: "center",
    display: "block",
    maxWidth: "550px",
  },
  paper: {
    cursor: "pointer",
    border: "1px solid #fff",
    padding: "1rem",
  },
  optionHintText: {
    fontSize: "0.75rem",
    borderTop: "1px solid #ddd",
    paddingTop: "1rem",
  },
  labelIcon: {
    "& svg": { fontSize: "3rem" },
  },
  labelText: {
    padding: "1rem",
  },
  activeColor: {
    color: "primary.main",
  },
  activePad: {
    background: "background.contrast",
    border: "1px solid",
    borderColor: "primary.main",
  },
  errorPad: {
    border: "1px solid red",
  },
};

export default radioPadStyle;
